"use strict";

var _classCallCheck = require("/Users/georgiavramov/limechain/new-abridged/abridged/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/georgiavramov/limechain/new-abridged/abridged/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/Users/georgiavramov/limechain/new-abridged/abridged/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/Users/georgiavramov/limechain/new-abridged/abridged/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var contracts_1 = require("@abridged/contracts");

var eth_sdk_1 = require("eth-sdk");

var AbstractContract = /*#__PURE__*/function (_eth_sdk_1$Contract) {
  _inherits(AbstractContract, _eth_sdk_1$Contract);

  var _super = _createSuper(AbstractContract);

  function AbstractContract(sdk, name) {
    _classCallCheck(this, AbstractContract);

    return _super.call(this, contracts_1.getContractAbiDefinition(name), contracts_1.getContractAddress(name, sdk.state.networkVersion), sdk.query);
  }

  _createClass(AbstractContract, [{
    key: "getMethodSignature",
    value: function getMethodSignature(name) {
      return this.methods[name].signature;
    }
  }]);

  return AbstractContract;
}(eth_sdk_1.Contract);

exports.AbstractContract = AbstractContract;